export default "__VITE_ASSET__vxWv6sHw__"